import { render, staticRenderFns } from "./location_device_item.vue?vue&type=template&id=56e5e70a"
import script from "./location_device_item.vue?vue&type=script&lang=js"
export * from "./location_device_item.vue?vue&type=script&lang=js"
import style0 from "./location_device_item.vue?vue&type=style&index=0&id=56e5e70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports